import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './RegistrationSteps.module.css';
import { useAuth } from '../context/AuthContext';
import { FiCheck, FiUser, FiShield, FiFileText, FiCreditCard } from 'react-icons/fi';

const RegistrationSteps = ({ currentStep }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const steps = [
    { name: 'Basic Details', path: '/basic-details', icon: <FiUser /> },
    { name: 'KYC Details', path: '/kyc', icon: <FiShield /> },
    { name: 'Additional Info', path: '/additional-details', icon: <FiFileText /> },
    { name: 'Bank Details', path: '/bank-details', icon: <FiCreditCard /> },
  ];

  // Logic: Registration itself is step 1. So if user exists, step 1 is complete.
  let lastCompletedStepIndex = 0; // Step 1 (index 0) is always complete for a logged-in user
  if (user) {
    if (user.kycStatus === 'submitted' || user.kycStatus === 'pending' || user.kycStatus === 'approved') {
      lastCompletedStepIndex = 1;
    }
    if (user.additionalDetailsStatus === 'submitted' || user.additionalDetailsStatus === 'pending' || user.additionalDetailsStatus === 'approved') {
      lastCompletedStepIndex = 2;
    }
    if (user.bankStatus === 'submitted' || user.bankStatus === 'pending' || user.bankStatus === 'approved') {
      lastCompletedStepIndex = 3;
    }
  }

  const highestAccessibleStep = Math.min(lastCompletedStepIndex + 1, steps.length - 1);

  const handleStepClick = (stepIndex) => {
    if (stepIndex <= highestAccessibleStep) {
      navigate(steps[stepIndex].path);
    }
  };

  return (
    <div className={styles.stepperWrapper}>
      <div className={styles.stepperContainer}>
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = index <= lastCompletedStepIndex;
          const isActive = stepNumber === currentStep;
          const isAccessible = index <= highestAccessibleStep;

          return (
            <React.Fragment key={index}>
              <div
                className={`${styles.stepItem} ${isActive ? styles.active : ''} ${isCompleted ? styles.completed : ''} ${isAccessible ? styles.accessible : ''}`}
                onClick={() => handleStepClick(index)}
              >
                <div className={styles.iconContainer}>
                  {isCompleted && !isActive ? <FiCheck className={styles.checkIcon} /> : step.icon}
                </div>
                <div className={styles.labelContainer}>
                  <span className={styles.stepName}>{step.name}</span>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className={`${styles.connector} ${isCompleted ? styles.connectorCompleted : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default RegistrationSteps;
